import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

// Order matters: brand tokens first, then the global layer that consumes them.
import './styles/tokens.css';
import './styles/global.css';

const container = document.getElementById('root');
if (!container) throw new Error('Console mount point #root is missing from index.html.');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
